var React = require('react');

function InfoConciergeInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zM7 6v6h2V6H7zm0-3v2h2V3H7z","fill":"currentColor","fillRule":"evenodd"}));
}

InfoConciergeInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = InfoConciergeInline;

InfoConciergeInline.default = InfoConciergeInline;
